import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './IndustriesSection.css';
import RetailImage from "../assets/images/retail-ecommerce.jpg";
import FinanceImage from "../assets/images/finance-banking.jpg";
import HealthcareImage from "../assets/images/healthcare.jpg";
import ManufacturingImage from "../assets/images/manufacturing.jpg";
import TechnologyImage from "../assets/images/technology.jpg";

const IndustriesSection = () => {
  const navigate = useNavigate();
  
  const industries = [
    {
      title: 'Retail & E-commerce',
      description: 'In retail, technology-driven solutions are transforming the way businesses interact with customers and manage operations.',
      image: RetailImage,
      link: '/blogs'
    },
    {
      title: 'Finance & Banking',
      description: 'Empowering financial institutions with cutting-edge solutions for digital transformation and enhanced customer experience.',
      image: FinanceImage,
      link: '/blogs'
    },
    {
      title: 'Healthcare & Life Sciences',
      description: 'Innovative solutions driving better patient care and operational efficiency in healthcare organizations.',
      image: HealthcareImage,
      link: '/blogs'
    },
    {
      title: 'Manufacturing & Supply Chain',
      description: 'Smart manufacturing solutions and supply chain optimization for enhanced productivity and efficiency.',
      image: ManufacturingImage,
      link: '/blogs'
    },
    {
      title: 'Technology & SaaS',
      description: 'Enabling technology companies to build, scale, and optimize their software solutions and services.',
      image: TechnologyImage,
      link: '/blogs'
    }
  ];

  return (
    <section className="industries-section-new">
      <div><h2 className="industries-title">Industries We Serve</h2></div>
      <div className="divider" style={{ width: "90%" }}></div>
      
      <div className="industries-grid">
        {/* First Row: 70-30 split */}
        <div className="row row-70-30">
          <Link to={industries[0].link} className="industry-card">
            <img src={industries[0].image} alt={industries[0].title} />
            <div className="industry-label">{industries[0].title}</div>
            <div className="industry-description">{industries[0].description}</div>
          </Link>
          <Link to={industries[1].link} className="industry-card">
            <img src={industries[1].image} alt={industries[1].title} />
            <div className="industry-label">{industries[1].title}</div>
            <div className="industry-description">{industries[1].description}</div>
          </Link>
        </div>

        {/* Second Row: 30-70 split */}
        <div className="row row-30-70">
          <Link to={industries[2].link} className="industry-card">
            <img src={industries[2].image} alt={industries[2].title} />
            <div className="industry-label">{industries[2].title}</div>
            <div className="industry-description">{industries[2].description}</div>
          </Link>
          <Link to={industries[3].link} className="industry-card">
            <img src={industries[3].image} alt={industries[3].title} />
            <div className="industry-label">{industries[3].title}</div>
            <div className="industry-description">{industries[3].description}</div>
          </Link>
        </div>

        {/* Third Row: 80-20 split */}
        <div className="row row-80-20">
          <Link to={industries[4].link} className="industry-card">
            <img src={industries[4].image} alt={industries[4].title} />
            <div className="industry-label">{industries[4].title}</div>
            <div className="industry-description">{industries[4].description}</div>
          </Link>
          <button className="know-more-btn" onClick={() => navigate("/blogs")}>
            Know us more
            <svg
              className="arrow-icon"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5 12H19M19 12L12 5M19 12L12 19"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;